import { render } from "./favorite_button.vue?vue&type=template&id=3b6c3c4d"
import script from "./favorite_button.js?vue&type=script&lang=js&external"
export * from "./favorite_button.js?vue&type=script&lang=js&external"

import "./favorite_button.vue?vue&type=style&index=0&id=3b6c3c4d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__